<div class="select-shiyoulot-header">
  <form #shiyoulotSearchForm="ngForm">
    <div fxLayout="row wrap" fxLayoutGap="50px">
        <div fxLayout="row wrap" fxLayoutGap="20px">
          <ng-select *ngIf="selectShiyoulotDialogData.keishaShubetsu"
                     style="width: 200px;"
                     required
                     bindLabel="farmKeisha"
                     bindValue="id"
                     placeholder="鶏舎 *"
                     appendTo="body"
                     [items]="masterService.keishaMaster | listFilter: 'keishaShubetsu': selectShiyoulotDialogData.keishaShubetsu: false
                                                         | isDeletedFilter:false"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [clearable]="false"
                     [(ngModel)]="selectedKeishaId"
                     name="keishaId">
          </ng-select>
          <ng-select *ngIf="!selectShiyoulotDialogData.keishaShubetsu"
                     style="width: 200px;"
                     required
                     bindLabel="farmKeisha"
                     bindValue="id"
                     placeholder="鶏舎 *"
                     appendTo="body"
                     [items]="masterService.keishaMaster | isDeletedFilter:false"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [clearable]="false"
                     [(ngModel)]="selectedKeishaId"
                     name="keishaId">
          </ng-select>
          <ng-select style="width: 200px;"
                     disabled
                     required
                     bindLabel="name"
                     bindValue="id"
                     placeholder="鶏種 *"
                     [items]="masterService.keishuMaster | isDeletedFilter: false"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [clearable]="false"
                     [(ngModel)]="selectShiyoulotDialogData.keishuId"
                     name="keishuId">
          </ng-select>
          <div>
            <mat-form-field appearance="legacy" class="date-input">
              <mat-label>餌付日</mat-label>
              <input matInput
                     required readonly
                     [matDatepicker]="selectedEdukeDatePicker"
                     [(ngModel)]="selectShiyoulotDialogData.edukeDate"
                     (click)="selectedEdukeDatePicker.open()"
                     name="selectedEdukeDatePicker">
              <mat-datepicker-toggle matSuffix [for]="selectedEdukeDatePicker"></mat-datepicker-toggle>
              <mat-datepicker touchUi #selectedEdukeDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="center">
          <button style="margin-right: 24px"
                  mat-raised-button
                  color="primary"
                  [disabled]="shiyoulotSearchForm.invalid"
                  (click)="searchShiyoulot()">
            検索
          </button>
        </div>
    </div>
  </form>
</div>
<div>
  <ng-container *ngIf="(shiyoulotListObservable | async) as shiyoulotList">
    <ng-container *ngIf="shiyoulotList && shiyoulotList.length > 0 else noShiyoulot">
      <ng-container *ngFor="let shiyoulot of shiyoulotList">
        <mat-expansion-panel [expanded]="true" style="margin: 24px 24px 7px 24px">
          <mat-expansion-panel-header>
            <div class="shiyoulot-summary">
              <span>飼養ロット番号：{{shiyoulot.id}}</span>
              <span>名前：{{shiyoulot.name}}</span>
              <span>鶏舎：{{commonService.getName(masterService.keishaMaster, shiyoulot.keishaId, 'farmKeisha')}}</span>
            </div>
          </mat-expansion-panel-header>
          <table class="event-list">
            <thead>
            <tr id="event-list-tr">
              <th>出荷先</th>
              <th>出荷先鶏舎</th>
              <th>予定移行日</th>
              <th>予定出荷日</th>
              <th>予定出荷羽数</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngTemplateOutlet="shukkaEventMap.get(shiyoulot.id!) && shukkaEventMap.get(shiyoulot.id!)!.length > 0
                                              ? shukkaTempRef : templateRefService.noDataTempRef;
                                             context: {
                                              stylesObj: commonService.getStyle('event-list-tr'),
                                              colNum: 5,
                                              msg: '出荷予定がありません。',
                                              shiyoulotId: shiyoulot.id!
                                              }">
            </ng-container>
            </tbody>
          </table>
        </mat-expansion-panel>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<ng-template #shukkaTempRef let-shiyoulotId="shiyoulotId">
  <tr *ngFor="let shukkaEvent of shukkaEventMap.get(shiyoulotId)"
      matTooltip="既に他の入荷イベントと紐づいています。"
      [matTooltipDisabled]="!isHimodukiDone(shukkaEvent, selectShiyoulotDialogData)"
      [ngClass]="{'invalid': isHimodukiDone(shukkaEvent, selectShiyoulotDialogData),
                  'cursor-pointer': !isHimodukiDone(shukkaEvent, selectShiyoulotDialogData)}"
      (click)="commonService.log(shukkaEvent);
                         selectShukkaEvent(shiyoulotId, shukkaEvent, selectShiyoulotDialogData)">
    <td>{{commonService.getName(masterService.shukkaSakiMaster, shukkaEvent.shukkaSakiId)}}</td>
    <td>{{commonService.getName(masterService.keishaMaster, shukkaEvent.shukkaKeishaId, 'farmKeisha')}}</td>
    <td>{{shukkaEvent.yoteiIkouDate}}</td>
    <td>{{shukkaEvent.yoteiShukkaDate}}</td>
    <td>{{shukkaEvent.yoteiShukkaWasuu}}</td>
  </tr>
</ng-template>
<ng-template #noShiyoulot>
  <div class="header" style="height: 32vw" fxLayout="row" fxLayoutAlign="center center">
    <h3 style="margin: 0">飼養ロットがありません。</h3>
  </div>
</ng-template>
